import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { HeartButton } from "@/components/HeartButton";
import { SERVICES, IMAGES } from "@/data/content";

const ServiceCard = ({ svc, index }) => (
  <Reveal delay={Math.min(index * 0.05, 0.3)} className="h-full">
    <Link
      data-testid={`service-card-${svc.slug}`}
      to={`/services/${svc.slug}`}
      className="group flex flex-col h-full rounded-2xl border border-kiki-line bg-white overflow-hidden hover:border-kiki-gold/40 hover:-translate-y-1 transition-all duration-300"
    >
      <div className="relative h-44 overflow-hidden shrink-0">
        <img
          src={IMAGES[svc.image]}
          alt={svc.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 right-3">
          <HeartButton
            name={`${svc.title} — consulting service`}
            price="Pricing as per scope"
            testid={`service-heart-${svc.slug}`}
          />
        </div>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-display text-2xl font-medium text-kiki-ink leading-tight">{svc.title}</h3>
          <span className="w-8 h-8 rounded-full border border-kiki-line flex items-center justify-center text-kiki-ink group-hover:bg-kiki-gold group-hover:border-kiki-gold group-hover:text-[#FAF5EC] transition-all duration-300 shrink-0">
            <ArrowRight className="w-3.5 h-3.5" />
          </span>
        </div>
        <div className="w-10 h-px bg-kiki-line my-3" />
        <p className="text-sm text-kiki-muted font-light leading-relaxed">{svc.line}</p>
      </div>
    </Link>
  </Reveal>
);

const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-16 sm:py-24 bg-[#FAF5EC]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal><Eyebrow>What we do</Eyebrow></Reveal>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mt-3 mb-8">
        <Reveal delay={0.1}>
          <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tight text-kiki-ink leading-[1.05]">
            Our Services
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-base text-kiki-muted max-w-sm leading-relaxed">
            Twelve practice areas across people, process, data &amp; brand. Tap the heart to shortlist any service.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((svc, i) => (
          <ServiceCard key={svc.slug} svc={svc} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Services;
